import type { ProductDetailPageFragmentFragment } from "@commerce-frontend/types";
import { Container } from "@commerce-frontend/ui/base/Container/Container";
import { Section } from "@commerce-frontend/ui/base/Section/Section";
import { MarkdownContainer } from "@commerce-frontend/ui/components/MarkdownContainer/MarkdownContainer";
import { useTranslations } from "next-intl";
import { ProductInstructions } from "./_components/ProductInstructions/ProductInstructions";
import { ProductMaterials } from "./_components/ProductMaterials/ProductMaterials";

type Props = {
	baseVariant: ProductDetailPageFragmentFragment["variants"][0];
	product: ProductDetailPageFragmentFragment;
};

export const ProductInformationSection = ({ baseVariant, product }: Props) => {
	const t = useTranslations("ProductInformationSection");

	const description = baseVariant.description;
	const instructions = product.instructions;
	const materials =
		product.materials?.base ||
		product.materials?.filling ||
		product.materials?.lining ||
		product.materials?.outside;

	if (!description && !materials && !instructions) {
		return null;
	}

	return (
		<Section id="product-information" backgroundColor="gray">
			<Container>
				<div className="flex flex-col gap-7xl">
					<div>
						<h2 className="display-md mb-2xl font-semibold">{t("information")}</h2>
						{description ? (
							<MarkdownContainer className="prose prose-gray max-w-3xl">
								{description}
							</MarkdownContainer>
						) : null}
					</div>
					{instructions || materials ? (
						<div className="flex flex-col gap-6xl lg:flex-row lg:gap-7xl">
							{materials ? <ProductMaterials materials={product.materials} /> : null}
							{instructions?.length ? (
								<ProductInstructions instructions={product.instructions} />
							) : null}
						</div>
					) : null}
				</div>
			</Container>
		</Section>
	);
};
